export default {
	plans: {
		title: "Planos e Preços",
		subtitle: "Escolha o plano ideal para o seu terreiro",
		perMonth: "/mês",
		freeTrial: "30 dias grátis para testar",
		getStarted: "Começar Agora",
		empty: "Planos em breve",
		emptyDesc: "Estamos preparando os planos. Volte em breve!",
		backToStart: "Voltar ao início",
	},
	builder: {
		foundation: "Fundação",
		addons: "Adicionais",
		yourPlan: "Seu plano",
		includedAlways: "Incluído sempre",
		unlimitedChain: "Corrente ilimitada, tudo incluído",
		notInclude: "Não incluir",
		total: "Total",
		subscribeNow: "Assinar agora",
		editPlan: "Editar plano",
		editPlanTitle: "Monte seu plano",
		editDone: "Concluir",
		preselectionUnavailable: "O plano ou adicional escolhido anteriormente não está mais disponível. Revise a seleção abaixo antes de confirmar.",
		startFree: "Testar 30 dias grátis",
		trialNote: "Os adicionais não entram no teste grátis — assine para ativá-los desde o 1º dia.",
		trialConfirm: {
			title: "Teste grátis de 30 dias",
			message:
				"No teste grátis você usa as funções do plano, mas os adicionais (WhatsApp, Mercado Pago) não entram. Para usá-los, assine um plano.",
			withAddons:
				"Os adicionais que você escolheu ({addons}) não entram no teste grátis. Assine o plano para ativá-los desde o 1º dia.",
			subscribeInstead: "Assinar plano",
			continueTrial: "Continuar no teste grátis",
		},
		optional: "opcional",
		needMore: "Precisa de mais? Entre em contato!",
		needMoreSubject: "Preciso de um plano sob medida",
		group: {
			whatsapp: "Alertas WhatsApp",
			mercadoPago: "Integração Mercado Pago",
		},
	},
	trial: {
		banner: "Período de teste: {days} dias restantes",
	},
	voucher: {
		label: "Código do voucher",
		placeholder: "Ex: ORI2026",
		apply: "Aplicar",
		valid: "Voucher aplicado com sucesso!",
		invalid: "Voucher inválido",
		applied: "Desconto do voucher",
		activated: "Assinatura ativada com sucesso!",
	},
	dialog: {
		title: "Escolha seu plano",
		subtitle: "Selecione o plano para assinar",
		confirm: "Continuar",
		cancel: "Cancelar",
	},
	return: {
		checkingTitle: "Confirmando seu pagamento...",
		checkingDesc: "Isso leva só alguns segundos.",
		successTitle: "Obrigado pela aquisição!",
		successDesc: "Sua assinatura foi ativada.",
		successDescPlan: "Sua assinatura do plano {plan} foi ativada.",
		pendingTitle: "Estamos confirmando seu pagamento",
		pendingDesc: "A confirmação pode levar alguns minutos. Se o pagamento foi concluído, seu plano será ativado automaticamente. Se não foi concluído ou foi recusado, você pode tentar novamente na página do plano.",
		viewMyPlan: "Ver meu plano",
		goToDashboard: "Ir para o painel",
	},
	blocked: {
		ownerTitle: "Sua assinatura expirou",
		ownerDesc: "O período de teste terminou ou o pagamento não foi confirmado. Assine um plano para continuar usando o ORI.",
		memberTitle: "Acesso suspenso",
		memberDesc: "O acesso ao sistema está temporariamente suspenso. Entre em contato com o responsável pelo templo para regularizar a assinatura.",
		currentTemple: "Templo atual:",
		otherTemples: "Ou acesse outro templo da sua conta:",
		pendingCheckout: "Você começou a contratar um plano e não concluiu o pagamento:",
		resumeCheckout: "Continuar de onde parei",
		chooseAnother: "Escolher outro plano",
		logout: "Sair",
	},
	page: {
		title: "Meu Plano",
		plan: "Plano",
		trialExpiresIn: "Trial expira em",
		daysLeft: "({days} dias restantes)",
		nextPayment: "Próximo vencimento",
		accessUntil: "Acesso até",
		subscribeNow: "Assinar Agora",
		cancelSubscription: "Cancelar Assinatura",
		changePlan: "Mudar plano",
		paymentHistory: "Histórico de Pagamentos",
		noPayments: "Nenhum pagamento",
		noPaymentsDesc: "Seu histórico de pagamentos aparecerá aqui.",
		headerAmount: "Valor",
		headerStatus: "Status",
		headerPaidAt: "Pago em",
		headerPeriod: "Período",
		cancelTitle: "Cancelar Assinatura",
		cancelConfirm: "Tem certeza que deseja cancelar sua assinatura? O acesso será mantido até o fim do período atual.",
		cancelNo: "Não",
		cancelYes: "Sim, cancelar",
		cancelSuccess: "Assinatura cancelada. Acesso mantido até o fim do período.",
		errorSubscribe: "Erro ao iniciar assinatura",
		errorCancel: "Erro ao cancelar assinatura",
		errorLoad: "Erro ao carregar dados do plano",
		voucher: {
			comped: "Cortesia",
			compedUntil: "Cortesia até {date}",
			discountPercent: "Desconto de {value}%",
			discountAmount: "Desconto de R$ {value}",
			payFullPrice: "Pagar valor integral",
			payFullPriceConfirm: "A partir da próxima fatura, o Mercado Pago cobra o valor cheio do plano.",
			back: "Voltar",
			payFullPriceSuccess: "Desconto encerrado.",
			payFullPriceError: "Erro ao encerrar o desconto",
		},
		status: {
			TRIALING: "Período de Teste",
			ACTIVE: "Ativa",
			PAST_DUE: "Pagamento Pendente",
			SUSPENDED: "Suspensa",
			CANCELLED: "Cancelada",
			NO_SUBSCRIPTION: "Sem Assinatura",
		},
		statusDesc: {
			TRIALING: "Você está no período de teste gratuito.",
			ACTIVE: "Sua assinatura está ativa e em dia.",
			PAST_DUE: "Seu último pagamento falhou. Regularize para manter o acesso.",
			SUSPENDED: "Acesso suspenso. Assine para reativar.",
			CANCELLED: "Assinatura cancelada. O acesso segue até o fim do período atual.",
			CANCELLED_EXPIRED: "Assinatura cancelada e período encerrado. Assine para voltar a usar o ORI.",
			NO_SUBSCRIPTION: "Assine para começar a usar o ORI.",
		},
		paymentStatus: {
			PAID: "Pago",
			PENDING: "Pendente",
			FAILED: "Falhou",
			REFUNDED: "Reembolsado",
		},
	},
	usage: {
		title: "Uso do plano",
		unlimited: "ilimitado",
		estimate: "A quantidade de mensagens é uma estimativa e varia conforme os recursos ativados.",
		limitKey: {
			corrente: "Pessoas na corrente",
			whatsappMsgMonth: "Mensagens WhatsApp/mês",
		},
	},
	upgrade: {
		title: "Limite do plano atingido",
		cta: "Ver planos",
		defaultMessage:
			"Este recurso não está incluído no seu plano atual. Faça um upgrade para liberar.",
	},
	changePlan: {
		title: "Mudar de plano",
		current: "atual",
		upgradeNote:
			"Upgrade tem acesso imediato. A diferença proporcional dos dias restantes entra na próxima fatura.",
		downgradeNote:
			"A troca para o plano menor é agendada para o fim do período atual — o acesso continua até lá.",
		confirm: "Mudar plano",
		upgraded: "Plano alterado! Proporcional de R$ {amount} na próxima fatura.",
		scheduled: "Troca agendada para o fim do período atual.",
		changed: "Plano alterado com sucesso.",
		error: "Erro ao mudar de plano",
	},
	addons: {
		title: "Add-ons",
		subtitle: "Recursos extras para o seu plano",
		contracted: "Contratado",
		contract: "Contratar",
		change: "Trocar para esta faixa",
		remove: "Remover",
		perMonth: "/mês",
		prorationWarning:
			"Acesso liberado na hora. O valor proporcional aos dias restantes será somado à sua próxima fatura; as seguintes virão pelo valor cheio.",
		contractTitle: "Contratar add-on",
		activated: "Add-on ativado! Proporcional de R$ {amount} na próxima fatura.",
		activatedNoProration: "Add-on ativado!",
		removeTitle: "Remover add-on",
		removeText:
			"O add-on continua ativo até o fim do período atual e não será renovado. Não há reembolso.",
		removeScheduled: "Remoção agendada para o fim do período atual.",
		scheduledForEnd: "Alteração agendada para o fim do período atual.",
		pendingProration:
			"R$ {amount} (proporcional) serão somados à sua próxima fatura.",
		hasScheduledChange:
			"Você tem uma alteração de plano agendada para o fim do período atual.",
		error: "Erro ao alterar o add-on",
	},
};
